<template>
  <div>
    <router-view></router-view>
    <FundScreenerV2View v-if="!showingDetail" :class="{'tw-opacity-0': showingDetail}" />
  </div>
</template>

<script>
import FundScreenerV2View from '@frontend/dash3/js/views/FundScreenerV2View.vue';

export default {
  components: { FundScreenerV2View },
  computed: {
    // Based on route params
    showingDetail() {
      return !!this.$route.params.symbol;
    }
  }
}
</script>
